import constants from "./constants.js";
import localizationKeys from "../../../i18n/localizationKeys.js";
import dayjs from 'util/dayjs-init.js';
import { DATE_FORMAT } from "../../../constants/constants.js";
import { convertNumber, customIsNaN } from "../../cargo/pitchAndRoll/commonFunc.js";

export const getStatusList = (alarmList) => {
  const retList = alarmList?.length
    ? [
        "ALL",
        ...new Set(
          alarmList
            .map((d) => [d?.value])
            .flat()
            .filter((d) => ![null, undefined, "", "-"].includes(d))
        ),
      ]
    : [];

  return retList;
};

export const setWordTextData = (() => {
  let innerAction = null;
  let innerText = null;

  return {
    setAction: (action) => (innerAction = action),
    setText: (text) => (innerText = text),
    action: () => innerAction(innerText),
    getText: () => innerText,
  };
})();

export const isInitialState = (historyFilter) => {
  return (
    [null, "", undefined].includes(historyFilter.word) &&
    [null, "", undefined, "ALL"].includes(historyFilter.status) &&
    JSON.stringify({
      occurrenceStart: historyFilter.occurrenceStart,
      occurrenceEnd: historyFilter.occurrenceEnd,
      recoveryTimeStart: historyFilter.recoveryTimeStart,
      recoveryTimeEnd: historyFilter.recoveryTimeEnd,
    }) === JSON.stringify(constants.DURATION_INITIAL_STATE)
  );
};

const descendingComparator = (a, b, orderBy, isExistingThresholdList = []) => {
  const latest = dayjs.utc().format(DATE_FORMAT);
  let aVal, bVal;
  if (orderBy === "chNo") {
    aVal = customIsNaN(a[orderBy]) ? latest : convertNumber(a[orderBy]);
    bVal = customIsNaN(b[orderBy]) ? latest : convertNumber(b[orderBy]);
  } else if(orderBy === "notification") {
    aVal = isExistingThresholdList.includes(String(parseInt(a.chNo)));
    bVal = isExistingThresholdList.includes(String(parseInt(b.chNo)))
  } else {
    aVal = a[orderBy] ?? latest;
    bVal = b[orderBy] ?? latest;
  }

  if (bVal < aVal) return 1;
  else if (bVal > aVal) return -1;
  else return 0;
};

export const getComparator = (order, orderBy, isExistingThresholdList = []) =>
  order === constants.ORDER.DESC
    ? (a, b) => descendingComparator(a, b, orderBy, isExistingThresholdList)
    : (a, b) => -descendingComparator(a, b, orderBy, isExistingThresholdList);

export const stableSort = (array, comparator, orderBy) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const channelListHeader = (t, isXsDown) => [
  {
    id: constants.HEADER_ID.CHANNEL_NUMBER,
    name: "Ch. No.",
    align: "left",
    sortable: true,
    tabletWidth: 100,
  },
  {
    id: constants.HEADER_ID.CHANNEL_NAME,
    name: t(localizationKeys.ChannelName),
    align: "left",
    sortable: true,
    style: { minWidth: "80px" },
    tabletWidth: 200,
  },
  {
    id: constants.HEADER_ID.VALUE,
    name: t(localizationKeys.Value_lower),
    align: "center",
    sortable: false,
    style: { minWidth: "56px" },
    tabletWidth: 150
  },
  {
    id: constants.HEADER_ID.STATUS,
    name: t(localizationKeys.Status_lower),
    align: "center",
    sortable: true,
    style: { minWidth: "75px" },
    tabletWidth: 80,
  },
  {
    id: constants.HEADER_ID.Notification,
    name: t(localizationKeys.Notification_Lower),
    align: "center",
    sortable: true,
    style: { minWidth: "75px" },
    tabletWidth: 60,
  },
];

export const sortFunc = (array, order) => {
  if (order === constants.ORDER.ASC) {
    return array.sort((a, b) => a - b);
  }
  if (order === constants.ORDER.DESC) {
    return array.sort((a, b) => -(a - b));
  }
};
